import { TAB_PARAM_KEY } from '../../../constants/route'

export function getEntityPageProfileLayoutEntityKey(params) {
  return JSON.stringify(
    Object.entries(params).filter(([name]) => name !== TAB_PARAM_KEY)
  )
}
